import { na1 } from 'hubspot-url-utils/hublets';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import getLang from 'LearningCenterUI/utils/getLang';
// @ts-expect-error untyped dependency
import FormattedDuration from 'I18n/components/FormattedDuration';

//@ts-expect-error Could not find declaration file for module
import chapterThumbnailUrl from 'bender-url!../../../images/pngs/chapter_thumbnail.png';
//@ts-expect-error Could not find declaration file for module
import practicalExerciseThumbnailUrl from 'bender-url!../../../images/pngs/practical_exercise_thumbnail.png';
//@ts-expect-error Could not find declaration file for module
import quizThumbnailUrl from 'bender-url!../../../images/pngs/quiz_thumbnail.png';
import UsageTracker from '../../utils/UsageTracker';
import { FILTER_TYPES } from '../../constants/TopFilterConstants';
import { CardMenuIcon } from '../../features/cardMenu';
import { useFullLesson } from '../../features/lessons/lessonQueries';
// @ts-expect-error Could not find a declaration file for module
import { useSearchParam } from '../../hooks/searchParamHooks';
//@ts-expect-error Could not find declaration file for module
import { getLesson } from '../../selectors/lessonSelectors';
import { getFullUrl } from 'hubspot-url-utils';
import { useAvailableLanguages } from '../../features/contentLanguage';
import InstructorList from '../../components/InstructorList';
import { OverviewContent } from '../../features/overview/components/OverviewContent';
import { OverviewModalCurriculumSection } from '../../features/overview/components/OverviewModalCurriculumSection';
import { OverviewModalDescriptionSection } from '../../features/overview/components/OverviewModalDescriptionSection';
import { useOverviewNavigation } from '../../features/overview/overviewRouting';
import ACInlineContentCard from 'academy-common-lib/components/card/ACInlineContentCard';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FallbackThumbnailUrls = {
  CHAPTER: chapterThumbnailUrl,
  PRACTICAL_EXERCISE_FLOW: practicalExerciseThumbnailUrl,
  QUIZ: quizThumbnailUrl
};
const LessonOverviewModalContainer = ({
  lessonId,
  language: languageFromProps,
  allowFullWidthChildren,
  source
}) => {
  const [[searchParamLanguage]] = useSearchParam(FILTER_TYPES.LANGUAGE);
  const {
    goTo
  } = useOverviewNavigation();
  const {
    availableLanguagesLoading,
    availableLanguagesData
  } = useAvailableLanguages('lesson', lessonId);
  const language = useMemo(() => {
    const chosenLanguage = (languageFromProps || searchParamLanguage || getLang()).toUpperCase();
    if (availableLanguagesData && availableLanguagesData.length && !availableLanguagesData.includes(chosenLanguage)) {
      // default to English if available
      return availableLanguagesData.includes('EN') ? 'EN' : availableLanguagesData[0];
    }
    return chosenLanguage;
  }, [availableLanguagesData, languageFromProps, searchParamLanguage]);
  const {
    lessonLoading: loading,
    lesson,
    lessonError: error
  } = useFullLesson(Number(lessonId), language);
  const lessonContent = useSelector(state => getLesson(state, {
    lessonId
  }));
  const deprecated = lessonContent && lessonContent.get('deprecated');
  const deprecationCta = lessonContent && lessonContent.get('deprecationCta');
  const hubspotDomain = getFullUrl('app', {
    hubletOverride: na1
  });
  const professors = useMemo(() => {
    if (!lesson) return [];
    const professorsById = {};
    lesson.content.forEach(asset => {
      if (asset.professors) {
        asset.professors.forEach(professor => {
          professorsById[professor.id] = professor;
        });
      }
    });
    return Object.values(professorsById);
  }, [lesson]);
  const curriculumContent = useMemo(() => {
    if (!lesson) return [];
    return lesson.content.filter(content => content.contentType !== 'LINK');
  }, [lesson]);
  const handleChangeSelectedLanguage = ({
    target: {
      value
    }
  }) => {
    UsageTracker.track('interaction', {
      action: 'overview-modal-change-language',
      appearsIn: source,
      lessonId: lesson ? lesson.id : null,
      name: lesson ? lesson.name : null,
      previousLanguage: language,
      newLanguage: value
    });
    goTo({
      id: lessonId,
      type: 'LESSON',
      language: value
    });
  };
  const handleEnroll = () => {
    UsageTracker.track('interaction', {
      action: 'overview-modal-enroll',
      appearsIn: source,
      contentLanguage: language,
      contentType: 'LESSON',
      lessonId: lesson ? lesson.id : null,
      name: lesson ? lesson.name : null
    });
  };
  const handleContentClick = (content, index) => () => {
    UsageTracker.track('interaction', {
      action: 'content-card-click',
      contentType: 'ASSET',
      assetId: content.id,
      appearsIn: 'lesson-overview-curriculum',
      position: index + 1,
      name: content.name,
      style: 'reduced',
      language
    });
  };
  const handleOrganisationUrlClick = (professorId, organisation, organisationUrl) => () => {
    UsageTracker.track('interaction', {
      action: 'professor-organisation-click',
      contentType: 'LESSON',
      appearsIn: 'lesson-overview-curriculum',
      organisation,
      organisationUrl,
      professorId,
      lessonId
    });
  };
  const getContentThumbnail = content => {
    if (content.content_type === 'VIDEO') {
      return `${hubspotDomain}/api/video/v1/public/${content.reference}/poster?portalId=${content.hubId}`;
    } else {
      return content.previewThumbnailSquareUrl || FallbackThumbnailUrls[content.contentType];
    }
  };
  const getCurriculumDuration = content => new Date().getTime() - (content.duration || 0) * 1000;
  return /*#__PURE__*/_jsxs(OverviewContent, {
    allowFullWidthChildren: allowFullWidthChildren,
    assetLanguage: language,
    deprecated: deprecated,
    deprecationCta: deprecationCta,
    error: error,
    fallbackThumbnailUrl: lesson && lesson.previewThumbnailRectangleUrl,
    headerIcons: /*#__PURE__*/_jsx(CardMenuIcon, {
      item: {
        id: lessonId,
        language,
        type: 'LESSON'
      },
      use: "on-dark"
    }),
    lessonId: lessonId.toString(),
    loading: loading || availableLanguagesLoading,
    children: [/*#__PURE__*/_jsx(OverviewModalDescriptionSection, {
      availableLanguages: availableLanguagesData,
      availableLanguagesLoading: availableLanguagesLoading,
      contentList: lesson && lesson.content,
      description: lesson && lesson.description,
      duration: lesson && /*#__PURE__*/_jsx(FormattedDuration, {
        from: new Date().getTime() - lesson.duration * 1000
      }),
      hasStudyGuide: lesson && !!lesson.studyGuide,
      id: lesson && lesson.id,
      onChangeSelectedLanguage: handleChangeSelectedLanguage,
      onEnroll: handleEnroll,
      selectedLanguage: language,
      title: lesson && lesson.name,
      type: "LESSON"
    }), !!professors.length && /*#__PURE__*/_jsx(InstructorList, {
      handleOrganisationUrlClick: handleOrganisationUrlClick,
      language: language,
      padding: "800",
      professors: professors
    }), !!curriculumContent.length && /*#__PURE__*/_jsx(OverviewModalCurriculumSection, {
      children: /*#__PURE__*/_jsx(TFlex, {
        direction: "column",
        gap: 28,
        children: curriculumContent.map((content, index) => /*#__PURE__*/_jsx(ACInlineContentCard, {
          description: /*#__PURE__*/_jsx(FormattedDuration, {
            from: getCurriculumDuration(content)
          }),
          name: content.name,
          onClick: handleContentClick(content, index),
          size: "extra-small",
          thumbnailSrc: getContentThumbnail(content),
          to: `/lessons/${lessonId}/${content.id}?language=${language}`,
          use: "on-surface-recessed"
        }, content.id))
      })
    })]
  });
};
export default LessonOverviewModalContainer;